import React,{useEffect, useState} from 'react';
import Button, {
    buttonTypes,
    buttonSizes,
    buttonTextSizes,
    buttonFunctions,
} from '../shared/Button';
import '../../scss/partials/assignDevices/assignDevices.css';
import Suggestion from './AssignSuggestions';
import ShowCategory from './ShowCategory';
import LoadingSpinner from '../shared/LoadingSpinner';
import { connect } from 'react-redux';
import { loadAssignmentSummary, loadCategoryDetails } from '../../redux/actions/assignDevicesActions';
import { loadUnmatchedDevices } from '../../redux/actions/assignDevicesActions';
import BreadCrumb from '../shared/BreadCrumbs';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';

export function UnConnectedAssignDevicesOptions(props){

    const {alarmDeviceTypes, apiSpinner} = props;

    const [assignTo, setAssignTo] = useState("users");
    const [clearAssignment, setClearAssignment] = useState("false");
    const [showSuggestion, setShowSuggestion] = useState(false);
    const [showCategory, setShowCategory] = useState(false);
    const optionArr = [];

    useEffect(()=>{
        let deviceTypes = alarmDeviceTypes ? Object.values(alarmDeviceTypes) : [];
        if (deviceTypes.length > 0){
            var firstelement = deviceTypes.shift()
            deviceTypes.sort(function (a, b) {
                let aParam = a['description'];
                let bParam = b['description'];
                if (typeof aParam === 'string') {
                  aParam = aParam.toUpperCase(); // ignore upper and lowercase
                }
                if (typeof bParam === 'string') {
                  bParam = bParam.toUpperCase(); // ignore upper and lowercase
                }
          
                if (aParam < bParam) {
                  return -1;
                }
                if (aParam > bParam) {
                  return 1;
                }
                // names must be equal
                return 0;
              })
           deviceTypes.unshift(firstelement)
        }
        deviceTypes.forEach((device)=>{
            optionArr.push({
                id:device.alarm_device_type,
                desc:device.description,
                checked:false
            })
        })
        setSelectedCategory([...optionArr]);
    },[alarmDeviceTypes]); // eslint-disable-line

    useEffect(() => {
        if( alarmDeviceTypes && Object.keys(alarmDeviceTypes).length === 0 ){
            props.dispatch(loadCategoryDetails());
        }
    }, []); // eslint-disable-line
    
    const [selectedCategory, setSelectedCategory] = useState([...optionArr]);
    let btndisable = selectedCategory.some( (o) => o.checked === true );

    function handleCategorySubmit(checkedCategory){
        setSelectedCategory([...checkedCategory]);
        handleCloseCategory();
    }

    function handleAssignToChange(event){
        setAssignTo(event.target.value)
    }

    function handleClearChange(event){
        setClearAssignment(event.target.value);
    }

    function makeRequest(){

        let category=[];
        if(selectedCategory[0].checked){
            category.push("all");
        }
        else{
            let temp = selectedCategory.slice(1);
            temp.forEach((c)=>{
                if(c.checked)
                    category.push(c.id);
            })
        }

        props.dispatch(loadAssignmentSummary({assignTo:assignTo,category:category.toString(),clear:clearAssignment}));
        props.dispatch(loadUnmatchedDevices({assignTo:assignTo,category:category.toString()}));
        handleShowSuggestion();
    }

    function handleShowSuggestion(){
        setShowSuggestion(true);
    }

    function handleCloseSuggestion(){
        setShowSuggestion(false);
    }

    function handleShowCategory(){
        setShowCategory(true);
    }

    function handleCloseCategory(){
        setShowCategory(false);
    }

    function assignDevicesOption(){
        return(
        <React.Fragment>
        <div className="grid-column-1">
            <div className="margin-10 grid-row-center">
                <div className="grid-start-2 text-medium item-container__main-text"
                    data-test="category-option-label">Category</div>
                <div className="grid-start-3">
                    <Button
                    buttonFunction={buttonFunctions.submit}
                    text={"Select Category"}
                    buttonType={buttonTypes.secondary}
                    buttonSize={buttonSizes.extraSmall}
                    buttonTextSize={buttonTextSizes.mediumSmall}
                    additionalStyles="no-margin"
                    disabled={false}
                    onClick={handleShowCategory}/>
                </div>
            </div>
            <div className="margin-10 grid-row-center">
                <div className="grid-start-2 text-medium item-container__main-text"
                    data-test="assign-option-label">Assign to
                </div>
                <div className="grid-start-3">
                    <select className="options-dropdown" value={assignTo} onChange={handleAssignToChange}>
                        <option value="users">Users</option>
                        <option value="units">Units</option>
                    </select>
                </div>
            </div>
            <div className="margin-10 grid-row-center">
                <div className="grid-start-2 text-medium item-container__main-text"
                    data-test="clear-option-label">
                        <label htmlFor="clear" >Clear existing Assignments<br/>(both users and units)</label></div>
                <div className="grid-start-3">
                    <select className="options-dropdown" value={clearAssignment} id="clear" onChange={handleClearChange}>
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                </div>
            </div>
        </div>
        <p></p>
        <Button
            buttonFunction={buttonFunctions.submit}
            text={"Submit"}
            buttonType={buttonTypes.blue}
            buttonSize={buttonSizes.extraSmall}
            buttonTextSize={buttonTextSizes.mediumSmall}
            additionalStyles="no-margin"
            disabled={!btndisable}
            onClick={makeRequest} />
        </React.Fragment>
        );
    }

    function displayOptions(){
        if (selectedCategory.length > 0 || apiSpinner.categoryListReturned) {
            return assignDevicesOption();
        } else {
            return (
              <div className="loading-spinner__user-list-container">
                <LoadingSpinner />
              </div>
            );
          }
    }

    const BreadCrumbArr = [
        {link:"/main/device_main.php",display:"Dashboard",type:'php'},
        {link:"/admin/install_setup.php",display:"Install Setup",type:'php'},
        {link:"../",display:"Assign Devices",type:'react'} ];

    return(
        <div className="container-full" data-test="assignDevicesOption-route">
        <div className="layout-container--wide content-container content-container--column content-container--shadow"
        data-test="display-container">
            <AccessControl feature={permissions.static.devices.assignDevices} permissionMessage={true}>
            {showCategory ? <ShowCategory categoryOptionsArr={selectedCategory} 
            submitText={"Save"} handleSubmit={handleCategorySubmit} handleClose={handleCloseCategory}/> : ""}
            {showSuggestion ? <Suggestion valueAssignTo={assignTo} handleClose={handleCloseSuggestion}/> : ""}
            <div className="flex-start width-100" data-test="breadcrumb">
                <BreadCrumb linkArr={BreadCrumbArr}></BreadCrumb>
            </div>
            <div className="width-100">
                <h1 className="no-margin text-center" data-test="display-title">Assign Devices to Units/Users</h1>
            </div>
            <hr/>
            {displayOptions()}
            </AccessControl>
        </div>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
      alarmDeviceTypes: state.assignDevices.categoryList,
      apiSpinner: state.ui.apiSpinner,
    };
};

export default connect(mapStateToProps)(UnConnectedAssignDevicesOptions);